import { useDimensionStore } from "@/stores/dimensionStore";

import { CategoryLegendBar } from "./CategoryLegendBar";
import { FeelingLegendBar } from "./FeelingLegendBar";

export function DimensionLegendBar() {
  const { dimensionType } = useDimensionStore();

  if (dimensionType === "feeling") {
    return <FeelingLegendBar />;
  }

  if (dimensionType === "category") {
    return <CategoryLegendBar />;
  }

  return null;
}
